module.exports = __webpack_public_path__ + "static/img/obsolete.9b02245.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/obsolete.png
// module id = INHj
// module chunks = 0